import React, { Fragment, useEffect, useRef, useState } from 'react'
import withFloor from '../../../../components/withFloor'
import tremApi from '../../../../util/tremApi'
import G from '../../../../util/globalFunction'


const MovePubAddrPage = props => {

    const params = props.params
    const PUB_ID = params.pubAddrID

    useEffect(async () => {
        await tremApi('/public/address/hm/access/json', {
           PUB_ID: params.pubAddrID || null,
        }).then(data => {

            const pubAddrs = data
            const SUCESS = pubAddrs.SUCESS
            const MESSAGE = pubAddrs.MESSAGE
            const OPER_FLAG = pubAddrs.OPER_FLAG
            let URL = null
            let param = null

            if(SUCESS == "S"){
                URL = pubAddrs.ADDR_INFO.URL;

                const PARAM_LIST = pubAddrs.ADDR_INFO.PARAM_LIST
                const PARAM_COUNT = pubAddrs.ADDR_INFO.PARAM_LIST_COUNT

                if(PARAM_COUNT > 0) {
                    param = {}
                    for (const value of PARAM_LIST) {

                        let PARAM_KEY = value.PARAM_KEY
                        let PARAM_VALUE = value.PARAM_VALUE

                        param[PARAM_KEY] = PARAM_VALUE
                    }
                }

                // console.log("## URL ", URL)
                // console.log("## param ", param)

                G.gotoPage(URL, param)
            }
        }).catch(err => {
            alert(G.t('trem.lang.home.0836'), err)/* 오류발생 */
        })
       
    }, [params])
    
    return (
        <Fragment>
             <div className="sub_wrap">
                <div className="inner">
                    <div class="sub_con page_move">
                        <div>
                            <span>페이지 이동 중</span>
                        </div>
                        <p>현재 페이지 이동 중 입니다.<br/>잠시만 기다려 주세요.</p>
                    </div>
                </div>
            </div>
        </Fragment>

    )
}



const layout = true
const title = '화면이동'
const keywords = []
const layoutMode = 'public'
export default withFloor({ layout, keywords, title, layoutMode })(MovePubAddrPage)